<script setup lang="ts">
import DevTools from '@/components/devtools/DevTools.vue';
import TestTools from '@/components/devtools/TestTools.vue';

const mode = import.meta.env.MODE;
const isDev = mode === 'development';
const isTestEnv = ['development', 'staging', 'preprod', 'uat'].includes(mode);
</script>

<template>
  <router-view />
  <DevTools v-if="isDev" />
  <TestTools v-if="isTestEnv" />
</template>
